import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'
import authReducer from './features/authReducer'
import challengeReducer from './features/challengeReducer'
import { USER_LOGOUT } from './types'

const appReducer = combineReducers({
  authReducer,
  challengeReducer,
})

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    storage.removeItem('persist:root')
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
